'use client';

import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { useState } from 'react';
import { Simplify } from '../../../../prismicio-types';

import styles from './serviceAdvantagesInner.module.scss';
import { Tabs } from '@/components';
import { ServiceContextList, ServiceImageList } from './index';
import { useVisible } from '@/hooks';

interface ServiceAdvantagesInnerProps {
  data: Simplify<Content.ServiceAdvantagesSliceDefaultPrimary>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const ServiceAdvantagesInner = ({
  data,
}: ServiceAdvantagesInnerProps) => {
  const [activeItem, setActiveItem] = useState<number>(0);
  const [isVisible, id] = useVisible();

  return (
    <article className={styles.inner} id={id}>
      <div
        className={`${styles.title_wrapper} ${isVisible ? styles.isVisible : ''}`}
      >
        <PrismicRichText field={data.title} components={components} />
      </div>
      <div className={styles.content}>
        <Tabs
          tabs={data.items.map((item) => item.tab_text)}
          onClick={setActiveItem}
          styles={styles.tabs}
          activeItem={activeItem}
          isVisible={isVisible}
          scrollDirection="right"
        />
        <ServiceImageList
          images={data.items.map((item) => item.image)}
          activeItem={activeItem}
          isVisible={isVisible}
        />
        <ServiceContextList
          items={data.items}
          activeItem={activeItem}
          isVisible={isVisible}
        />
      </div>
    </article>
  );
};
